var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36355 1.16505C8.23925 -0.38835 10.4274 -0.38835 11.3031 1.16505L17.6917 12.5038C18.5675 14.0573 17.4733 16 15.7219 16H2.94475C1.19338 16 0.0991893 14.0573 0.974973 12.5038L7.36355 1.16505ZM8.10881 1.60617L1.72028 12.9448C1.17597 13.9104 1.85593 15.1181 2.94475 15.1181H15.7219C16.8107 15.1181 17.4907 13.9105 16.9464 12.9449L10.5578 1.60617C10.0134 0.640599 8.65322 0.640599 8.10881 1.60617ZM9.33332 5.66914C9.57099 5.66914 9.76366 5.86656 9.76366 6.11009V7.99988C9.76366 8.24341 9.57099 8.44083 9.33332 8.44083C9.09566 8.44083 8.90299 8.24341 8.90299 7.99988V6.11009C8.90299 5.86656 9.09566 5.66914 9.33332 5.66914ZM8.90299 11.7795C8.90299 11.5359 9.09566 11.3385 9.33332 11.3385H9.34255C9.58021 11.3385 9.77288 11.5359 9.77288 11.7795C9.77288 12.023 9.58021 12.2204 9.34255 12.2204H9.33332C9.09566 12.2204 8.90299 12.023 8.90299 11.7795Z",
    fill: "#EA5449"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.490268873edd61daa22ffb44be8fa8fe.svg";
export { ForwardRef as ReactComponent };